(async() => {
    const { Core } = await importModule('Core');
    customElements.define('product-variant-selector', class extends Core {
        
        render() {
            this.addEventListener('change', this._onVariantChange.bind(this));
        }
        
        _onVariantChange(e) {
            // CUSTOM: Variants list radios carry the option value ids of their variant,
            // so hand all of them to the variant provider before publishing the change.
            const { optionValueIds } = e.target.dataset;
            if (optionValueIds) {
                const provider = this.closest('product-variant-provider');
                if (provider && provider.currentState) {
                    provider.currentState.optionValueIds = optionValueIds.split(',');
                }
            }

            this.publish('variant:change', {
                optionValueId: e.target.dataset.optionValueId, 
                optionIndex: e.target.dataset.optionIndex,
                variantId: e.target.dataset.variantId,
                imagePosition: e.target.dataset.imagePosition
            });
        }
    });
})()